import { FormattedMessage } from 'react-intl';
import ErrorLayout from './ErrorLayout';

const CorsError = () => (
  <ErrorLayout
    title={
      <FormattedMessage
        id="error.cors.title"
        defaultMessage="There is a configuration problem on the backend"
      />
    }
  >
    <>
      <p className="description">
        <FormattedMessage
          id="error.cors.body"
          defaultMessage="The backend server of your website is not answering, we apologize for the inconvenience. Please try to re-load the page and try again. If the problem persists please contact the site administrators."
        />
      </p>
      <p>
        <FormattedMessage id="error.thanks" defaultMessage="Thank you." />
      </p>
    </>
  </ErrorLayout>
);

export default CorsError;
